<template>
  <v-container>
    <h2>¿Cómo Registrar Personas?</h2>
    <br />
    <v-card>
      <v-card-actions class="justify-center">
        <ul>
          <h4>Glosario:</h4>
          <ol>
            <li>
              <b>RFC</b> se refiere al RFC del cliente o proveedor que va a
              registrar.
            </li>
            <li>
              <b>Razón Social</b> se refiere al nombre de una entidad o sociedad
              mercantil.
            </li>
            <li>
              <b>País</b> se refiere al país donde se encuentra el cliente o
              proveedor.
            </li>
            <li>
              <b>Estado</b> se refiere al estado que está dado de alta el
              cliente o proveedor.
            </li>
            <li>
              <b>Municipio</b> se refiere al municipio que está dado de alta por
              cliente o proveedor.
            </li>
            <li>
              <b>Localidad(Ciudad)</b> se refiere a la localidad, este puede ser
              el pueblo o ciudad que está dado de alta el cliente o proveedor.
            </li>
            <li>
              <b>Colonia</b> se refiere a la colonia que donde reside el cliente
              o proveedor.
            </li>
            <li>
              <b>Calle</b> se refiere a la calle donde reside el cliente o
              proveedor.
            </li>
            <li>
              <b>Código Postal</b> es la combinación de números que se asigna al
              cliente o proveedor para designar su localidad.
            </li>
            <li>
              <b>No. Exterior</b> se trata del número que aparece en la vivienda
              del cliente o proveedor, en el exterior de su domicilio/edificio.
            </li>
            <li>
              <b>No. Interior</b> se trata del domicilio principal que se
              encuentra en una vecindad o una urbanización.
            </li>
            <li>
              <b>Email</b> se refiere al correo electrónico principal que tiene
              el cliente o proveedor.
            </li>
            <li>
              <b>Email Opcional 1</b> se refiere al correo electrónico adicional
              que tiene el cliente o proveedor.
            </li>
            <li>
              <b>Email Opcional 2</b> se refiere al correo electrónico adicional
              que tiene el cliente o proveedor.
            </li>
            <li>
              <b>Uso de CFDI</b> el uso del CFDI es el registro sobre qué uso le
              dará el receptor al comprobante fiscal. Antes de emitir una
              factura, es necesario consultar con el cliente cuál es el uso que
              reportará ante Hacienda de esta.
            </li>
            <li>
              <b>Régimen Fiscal</b> es el conjunto de leyes y normas que rigen
              la situación tributaria de personas físicas y personas morales al
              momento de registrarse en el SAT.
            </li>
            <li>
              <b>RFC del Banco del Cliente</b> es el RFC del banco que está
              asociado el cliente o proveedor.
            </li>
            <li>
              <b>Cuenta del Cliente</b> es la cuenta de su respectiva
              tarjeta/cuenta de banco del cliente o proveedor.
            </li>
            <li>
              <b>Nombre del Banco</b> es el nombre del banco que está asociado
              al cliente o proveedor.
            </li>
          </ol>
          <div class="pa-2"></div>

          <v-divider class="pa-2"></v-divider>

          <h4>Pasos:</h4>
          <ol>
            <li>
              Todos los campos que se encuentren con <b>*</b> son necesarios
              para poder registrar a un cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>RFC </b>debido a que es obligatorio para el
              registro de un cliente o proveedor.
            </li>
            <li>
              Hacer click sobre <b>País</b> y seleccionar el país <b>México</b>,
              este es un campo obligatorio.
            </li>
            <li>
              Hacer click sobre <b>Estado</b> y seleccionar el Estado que
              necesite el usuario, este es un campo obligatorio.
            </li>
            <li>
              Llenar el campo <b>Municipio </b>debido a que es obligatorio para
              el registro de un cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>Colonia </b>debido a que es obligatorio para el
              registro de un cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>Calle </b>debido a que es obligatorio para el
              registro de un cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>Código Postal</b> debido a que es obligatorio
              para el registro de un cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>No. Exterior </b> debido a que es obligatorio
              para el registro de un cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>No. Interior </b>, este campo puede llenarse si
              el usuario lo necesita, no es obligatorio para el registro de un
              cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>Email</b> debido a que es obligatorio para el
              registro de un cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>Email opcional 1 </b>, este campo puede
              llenarse si el usuario lo necesita, no es obligatorio para el
              registro de un cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>Email opcional 2 </b>, este campo puede
              llenarse si el usuario lo necesita, no es obligatorio para el
              registro de un cliente o proveedor.
            </li>
            <li>
              Hacer click sobre
              <b>"Uso de CFDI"</b>
              para desplegar las opciones de unidad y seleccionar el uso que se
              le dará para el receptor sobre el comprobante fiscal, este campo
              es obligatorio para el registro de un cliente o proveedor.
            </li>
            <li>
              Hacer click sobre
              <b>"Régimen Fiscal"</b>
              para elegir la situación tributaria personas físicas o personas
              morales, este campo es obligatorio para el registro de un cliente
              o proveedor.
            </li>
            <li>
              Llenar el campo <b>RFC del Banco del Cliente</b>, este no es un
              campo obligatorio para el registro de un cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>Cuenta del Cliente</b>, este no es un campo
              obligatorio para el registro de un cliente o proveedor.
            </li>
            <li>
              Llenar el campo <b>Nombre del banco</b>, este no es un campo
              obligatorio para el registro de un cliente o proveedor.
            </li>
            <li>
              Hacer click en el botón <b>Registrar</b> para registrar
              exitosamente el cliente o proveedor.
            </li>
          </ol>
          <div class="pa-2"></div>

          <v-divider class="pa-2"></v-divider>
          <h4>Ejemplo:</h4>
          <v-img
            contain
            max-height="550"
            max-width="1000"
            src="../assets/RegistroPersonas.jpeg"
          ></v-img>
        </ul>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "DocsRegisterPeople",

  data: () => ({}),
  reveal: false,
};
</script>
